import { observer } from 'mobx-react-lite'
import {
  type IColumn,
  Table,
  type TableStore,
  type IRowDefault,
  TableSearch,
} from 'shared/ui/TableNew'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import styles from './styles.module.scss'

export type IInboxesTableProps<T extends IRowDefault> = {
  rows: T[]
  columns: IColumn<T>[]
  loading: boolean
  setSearch: (search: string) => void
  search: string
  tableStore: TableStore<T>
  onRowClick?: (row: T) => void
}

export const InboxesTable = observer(
  <T extends IRowDefault>({
    rows,
    columns,
    loading,
    setSearch,
    search,
    tableStore,
    onRowClick,
  }: IInboxesTableProps<T>) => {
    const getContent = () => {
      const searchField = <TableSearch value={search} onChange={setSearch} />

      if (!loading && !rows.length) {
        return (
          <>
            {searchField}
            <NoResultsFound label={'No results found'} />
          </>
        )
      }

      return (
        <>
          {searchField}
          <div className={styles.table}>
            <Table
              ariaLabel={'InboxesTable'}
              store={tableStore}
              columns={columns}
              rows={rows}
              loading={loading}
              onRowClick={onRowClick}
              hidePagination
            />
          </div>
        </>
      )
    }

    return <div className={styles.root}>{getContent()}</div>
  }
)
